import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const MetricResolutionForm = ({
	resolutionText,
	setResolutionText,
	startValue,
	setStartValue,
	targetValue,
	setTargetValue,
	unit,
	setUnit,
	resolutionYear,
}) => {
	const { t } = useLanguage();
	return (
		<>
			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('resolutionText')}</label>
				<input
					type='text'
					value={resolutionText}
					onChange={(e) => setResolutionText(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					required
				/>
			</div>

			<div className='grid grid-cols-2 gap-4 mb-4'>
				<div>
					<label className='block text-sm font-medium text-gray-700 mb-1'>{t('startValue')}</label>
					<input
						type='number'
						value={startValue}
						onChange={(e) => setStartValue(e.target.value)}
						className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					/>
				</div>

				<div>
					<label className='block text-sm font-medium text-gray-700 mb-1'>{t('targetValue')}</label>
					<input
						type='number'
						value={targetValue}
						onChange={(e) => setTargetValue(e.target.value)}
						className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					/>
				</div>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('unit')}</label>
				<input
					type='text'
					value={unit}
					onChange={(e) => setUnit(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					placeholder={t('unitExample')}
				/>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('year')}</label>
				<input
					type='number'
					value={resolutionYear}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm bg-gray-100'
					required
					disabled
				/>
			</div>
		</>
	);
};

export default MetricResolutionForm;
